import { useTranslation, Trans } from 'react-i18next';

import {
  type SupportedLanguageCodes,
  saveLanguageToLocalStorage,
  supportedLanguages,
} from '../i18n';

export { Trans };

export const useTranslate = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang: SupportedLanguageCodes) => {
    i18n.changeLanguage(lang);
    saveLanguageToLocalStorage(lang);
  };

  const translationExists = (key: string) => i18n.exists(key);

  return {
    t,
    translationExists,
    changeLanguage,
    selectedLanguage: i18n.language,
    supportedLanguages,
  };
};
